import { computed as e, createElementBlock as t, defineComponent as n, mergeProps as r, openBlock as i, renderSlot as a } from "vue";
import "@awesome.me/webawesome-pro/dist/components/button/button.js";
import "@awesome.me/webawesome-pro/dist/components/button-group/button-group.js";
// src/components/DsButton.vue?vue&type=script&setup=true&lang.ts
var o = /*@__PURE__*/ n({
	__name: "DsButton",
	props: { width: {} },
	setup(n) {
		let o = n, s = e(() => o.width ? "width:" + o.width + ";" : "");
		return (e, n) => (i(), t("wa-button", r(e.$attrs, {
			variant: "brand",
			style: s.value
		}), [a(e.$slots, "default", {}, void 0, !0)], 16));
	}
});
export { o as default };

//# sourceMappingURL=DsButton.vue_vue_type_script_setup_true_lang.js.map